import { createSlice } from '@reduxjs/toolkit';

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';

const initialState = {
  search: null,
  status: 'idle',
  error: null
};

export const itemSearchSlice = createSlice({
  name: 'itemSearch',
  initialState,
  reducers: {
    reset: (state, action) => {
      return initialState;
    },
    setActiveSearch: (state, action) => {
      state.search = action.payload;
    }
  },
  extraReducers: {
    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    }
  }
});

export const { setActiveSearch } = itemSearchSlice.actions;

export const selectActiveSearch = state => state.itemSearch.search;

export default itemSearchSlice.reducer;
